import { BehaviorSubject } from 'rxjs';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
import * as i0 from "@angular/core";
import * as i1 from "../../core/http/http.service";
export class UserService extends UnsubscribeOnDestroyAdapter {
    constructor(service) {
        super();
        this.service = service;
        this.USER_DATA = 'USER_DATA';
        this.PERMISSIONS = 'PERMISSIONS';
        this.USER_MODULES = 'USER_MODULES';
        this.LAST_LIST = 'LAST_LIST';
        const user = localStorage.getItem(this.USER_DATA);
        const permission = localStorage.getItem(this.PERMISSIONS);
        const modules = localStorage.getItem(this.USER_MODULES);
        const lastList = localStorage.getItem(this.LAST_LIST);
        this.user$ = new BehaviorSubject(user ? JSON.parse(user) : null);
        this.permissions$ = new BehaviorSubject(permission ? JSON.parse(atob(permission)) : null);
        this.modules$ = new BehaviorSubject(modules ? JSON.parse(atob(modules)) : null);
        this.lastVisitedList = lastList ? lastList : null;
        this.user = this.user$.asObservable();
        this.permissions = this.permissions$.asObservable();
        this.modules = this.modules$.asObservable();
    }
    set userData(user) {
        this.user$.next(user);
        localStorage.setItem(this.USER_DATA, JSON.stringify(user));
    }
    get userInfo() {
        return JSON.parse(JSON.stringify(this.user$.value));
    }
    set userPermissionData(permission) {
        this.permissions$.next(permission);
        localStorage.setItem(this.PERMISSIONS, btoa(JSON.stringify(permission)));
    }
    get userPermissionInfo() {
        return this.permissions$.value;
    }
    set userModulesData(modules) {
        this.modules$.next(modules);
        localStorage.setItem(this.USER_MODULES, btoa(JSON.stringify(modules)));
    }
    get userModulesInfo() {
        return this.modules$.value;
    }
    set lastListData(list) {
        this.lastVisitedList = list;
        localStorage.setItem(this.LAST_LIST, list);
    }
    get lastListConverted() {
        return this.lastVisitedList ? this.lastVisitedList.replace(' ', '_') : null;
    }
    getUserPermissions() {
        const userData = this.user$.value;
        if (userData) {
            this.subs.add(this.service
                .get(`permission/${userData.id}`, {})
                .subscribe((data) => {
                const permissions = data && Object.keys(data).length
                    ? data
                    : {
                        id: null,
                        user_id: userData.id,
                        update_order: {
                            not_signed: false,
                            dispatched: false,
                            in_transit: false,
                            delivered: false,
                            open_invoice: false,
                            damage: false,
                            paid_bills: false,
                            only_heavy_haul: false,
                            only_automotive: false
                        },
                        dispatch_privileges: {
                            perform_dispatch: false,
                            edit_dispatch: false,
                            use_carrier_match: false
                        },
                        payment_privileges: {
                            process_payment: false,
                            edit_carrier_terms: false
                        },
                        reports: false
                    };
                this.permissions$.next(permissions);
                localStorage.setItem(this.PERMISSIONS, btoa(JSON.stringify(permissions)));
            }));
        }
    }
}
UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(i0.ɵɵinject(i1.HttpService)); }, token: UserService, providedIn: "root" });
